export const ptCountriesList = [
  {
    standardizedName: "Mozambique",
    isoCountryCode: "MZ",
    name: "Moçambique",
  },
  {
    standardizedName: "France",
    isoCountryCode: "FR",
    name: "França",
  },
  {
    standardizedName: "Tonga",
    isoCountryCode: "TO",
    name: "Tonga",
  },
  {
    standardizedName: "Ireland",
    isoCountryCode: "IE",
    name: "Irlanda",
  },
  {
    standardizedName: "Greece",
    isoCountryCode: "GR",
    name: "Grécia",
  },
  {
    standardizedName: "Peru",
    isoCountryCode: "PE",
    name: "Peru",
  },
  {
    standardizedName: "Lithuania",
    isoCountryCode: "LT",
    name: "Lituânia",
  },
  {
    standardizedName: "Qatar",
    isoCountryCode: "QA",
    name: "Catar",
  },
  {
    standardizedName: "Comoros",
    isoCountryCode: "KM",
    name: "Comores",
  },
  {
    standardizedName: "Myanmar",
    isoCountryCode: "MM",
    name: "Mianmar (Birmânia)",
  },
  {
    standardizedName: "Senegal",
    isoCountryCode: "SN",
    name: "Senegal",
  },
  {
    standardizedName: "Gambia",
    isoCountryCode: "GM",
    name: "Gâmbia",
  },
  {
    standardizedName: "Andorra",
    isoCountryCode: "AD",
    name: "Andorra",
  },
  {
    standardizedName: "Saint Kitts and Nevis",
    isoCountryCode: "KN",
    name: "São Cristóvão e Névis",
  },
  {
    standardizedName: "Cambodia",
    isoCountryCode: "KH",
    name: "Camboja",
  },
  {
    standardizedName: "Thailand",
    isoCountryCode: "TH",
    name: "Tailândia",
  },
  {
    standardizedName: "Cayman Islands",
    isoCountryCode: "KY",
    name: "Ilhas Cayman",
  },
  {
    standardizedName: "New Caledonia",
    isoCountryCode: "NC",
    name: "Nova Caledônia",
  },
  {
    standardizedName: "Sint Maarten",
    isoCountryCode: "SX",
    name: "Sint Maarten",
  },
  {
    standardizedName: "Suriname",
    isoCountryCode: "SR",
    name: "Suriname",
  },
  {
    standardizedName: "Kosovo",
    isoCountryCode: "XK",
    name: "Kosovo",
  },
  {
    standardizedName: "Kuwait",
    isoCountryCode: "KW",
    name: "Kuwait",
  },
  {
    standardizedName: "Micronesia, Federated States of",
    isoCountryCode: "FM",
    name: "Micronésia",
  },
  {
    standardizedName: "Jordan",
    isoCountryCode: "JO",
    name: "Jordânia",
  },
  {
    standardizedName: "Uganda",
    isoCountryCode: "UG",
    name: "Uganda",
  },
  {
    standardizedName: "Singapore",
    isoCountryCode: "SG",
    name: "Singapura",
  },
  {
    standardizedName: "Equatorial Guinea",
    isoCountryCode: "GQ",
    name: "Guiné Equatorial",
  },
  {
    standardizedName: "Bosnia and Herzegovina",
    isoCountryCode: "BA",
    name: "Bósnia e Herzegovina",
  },
  {
    standardizedName: "Tanzania, United Republic Of",
    isoCountryCode: "TZ",
    name: "Tanzânia",
  },
  {
    standardizedName: "New Zealand",
    isoCountryCode: "NZ",
    name: "Nova Zelândia",
  },
  {
    standardizedName: "Aruba",
    isoCountryCode: "AW",
    name: "Aruba",
  },
  {
    standardizedName: "Macedonia, The Former Yugoslav Republic of",
    isoCountryCode: "MK",
    name: "Macedônia do Norte",
  },
  {
    standardizedName: "Togo",
    isoCountryCode: "TG",
    name: "Togo",
  },
  {
    standardizedName: "Zimbabwe",
    isoCountryCode: "ZW",
    name: "Zimbábue",
  },
  {
    standardizedName: "Sri Lanka",
    isoCountryCode: "LK",
    name: "Sri Lanka",
  },
  {
    standardizedName: "Malawi",
    isoCountryCode: "MW",
    name: "Malaui",
  },
  {
    standardizedName: "Dominica",
    isoCountryCode: "DM",
    name: "Dominica",
  },
  {
    standardizedName: "United Kingdom",
    isoCountryCode: "GB",
    name: "Reino Unido",
  },
  {
    standardizedName: "Latvia",
    isoCountryCode: "LV",
    name: "Letônia",
  },
  {
    standardizedName: "Bolivia",
    isoCountryCode: "BO",
    name: "Bolívia",
  },
  {
    standardizedName: "Israel",
    isoCountryCode: "IL",
    name: "Israel",
  },
  {
    standardizedName: "Congo, The Democratic Republic Of The",
    isoCountryCode: "CD",
    name: "Congo - Kinshasa",
  },
  {
    standardizedName: "Belize",
    isoCountryCode: "BZ",
    name: "Belize",
  },
  {
    standardizedName: "Mauritania",
    isoCountryCode: "MR",
    name: "Mauritânia",
  },
  {
    standardizedName: "Vanuatu",
    isoCountryCode: "VU",
    name: "Vanuatu",
  },
  {
    standardizedName: "Vietnam",
    isoCountryCode: "VN",
    name: "Vietnã",
  },
  {
    standardizedName: "Iceland",
    isoCountryCode: "IS",
    name: "Islândia",
  },
  {
    standardizedName: "Montenegro",
    isoCountryCode: "ME",
    name: "Montenegro",
  },
  {
    standardizedName: "Paraguay",
    isoCountryCode: "PY",
    name: "Paraguai",
  },
  {
    standardizedName: "Fiji",
    isoCountryCode: "FJ",
    name: "Fiji",
  },
  {
    standardizedName: "Brazil",
    isoCountryCode: "BR",
    name: "Brasil",
  },
  {
    standardizedName: "Portugal",
    isoCountryCode: "PT",
    name: "Portugal",
  },
  {
    standardizedName: "Cameroon",
    isoCountryCode: "CM",
    name: "Camarões",
  },
  {
    standardizedName: "Cuba",
    isoCountryCode: "CU",
    name: "Cuba",
  },
  {
    standardizedName: "Oman",
    isoCountryCode: "OM",
    name: "Omã",
  },
  {
    standardizedName: "Belgium",
    isoCountryCode: "BE",
    name: "Bélgica",
  },
  {
    standardizedName: "Morocco",
    isoCountryCode: "MA",
    name: "Marrocos",
  },
  {
    standardizedName: "Nauru",
    isoCountryCode: "NR",
    name: "Nauru",
  },
  {
    standardizedName: "Niger",
    isoCountryCode: "NE",
    name: "Níger",
  },
  {
    standardizedName: "Congo, Republic of the",
    isoCountryCode: "CG",
    name: "República do Congo",
  },
  {
    standardizedName: "Venezuela",
    isoCountryCode: "VE",
    name: "Venezuela",
  },
  {
    standardizedName: "Gabon",
    isoCountryCode: "GA",
    name: "Gabão",
  },
  {
    standardizedName: "Angola",
    isoCountryCode: "AO",
    name: "Angola",
  },
  {
    standardizedName: "Slovenia",
    isoCountryCode: "SI",
    name: "Eslovênia",
  },
  {
    standardizedName: "Rwanda",
    isoCountryCode: "RW",
    name: "Ruanda",
  },
  {
    standardizedName: "Sao Tome & Principe",
    isoCountryCode: "ST",
    name: "São Tomé e Príncipe",
  },
  {
    standardizedName: "Cyprus",
    isoCountryCode: "CY",
    name: "Chipre",
  },
  {
    standardizedName: "United States of America",
    isoCountryCode: "US",
    name: "Estados Unidos",
  },
  {
    standardizedName: "Tuvalu",
    isoCountryCode: "TV",
    name: "Tuvalu",
  },
  {
    standardizedName: "Chile",
    isoCountryCode: "CL",
    name: "Chile",
  },
  {
    standardizedName: "United States",
    isoCountryCode: "US",
    name: "Estados Unidos",
  },
  {
    standardizedName: "Moldova, Republic of",
    isoCountryCode: "MD",
    name: "Moldávia",
  },
  {
    standardizedName: "Saudi Arabia",
    isoCountryCode: "SA",
    name: "Arábia Saudita",
  },
  {
    standardizedName: "Nepal",
    isoCountryCode: "NP",
    name: "Nepal",
  },
  {
    standardizedName: "Bahrain",
    isoCountryCode: "BH",
    name: "Barein",
  },
  {
    standardizedName: "Viet Nam",
    isoCountryCode: "VN",
    name: "Vietnã",
  },
  {
    standardizedName: "Slovakia",
    isoCountryCode: "SK",
    name: "Eslováquia",
  },
  {
    standardizedName: "Kazakhstan",
    isoCountryCode: "KZ",
    name: "Cazaquistão",
  },
  {
    standardizedName: "Mali",
    isoCountryCode: "ML",
    name: "Mali",
  },
  {
    standardizedName: "Uruguay",
    isoCountryCode: "UY",
    name: "Uruguai",
  },
  {
    standardizedName: "Indonesia",
    isoCountryCode: "ID",
    name: "Indonésia",
  },
  {
    standardizedName: "China",
    isoCountryCode: "CN",
    name: "China",
  },
  {
    standardizedName: "Guinea-Bissau",
    isoCountryCode: "GW",
    name: "Guiné-Bissau",
  },
  {
    standardizedName: "Marshall Islands",
    isoCountryCode: "MH",
    name: "Ilhas Marshall",
  },
  {
    standardizedName: "Kenya",
    isoCountryCode: "KE",
    name: "Quênia",
  },
  {
    standardizedName: "Syrian Arab Republic",
    isoCountryCode: "SY",
    name: "Síria",
  },
  {
    standardizedName: "US",
    isoCountryCode: "US",
    name: "Estados Unidos",
  },
  {
    standardizedName: "South Sudan",
    isoCountryCode: "SS",
    name: "Sudão do Sul",
  },
  {
    standardizedName: "Croatia",
    isoCountryCode: "HR",
    name: "Croácia",
  },
  {
    standardizedName: "Albania",
    isoCountryCode: "AL",
    name: "Albânia",
  },
  {
    standardizedName: "Jamaica",
    isoCountryCode: "JM",
    name: "Jamaica",
  },
  {
    standardizedName: "Denmark",
    isoCountryCode: "DK",
    name: "Dinamarca",
  },
  {
    standardizedName: "Antigua and Barbuda",
    isoCountryCode: "AG",
    name: "Antígua e Barbuda",
  },
  {
    standardizedName: "Nicaragua",
    isoCountryCode: "NI",
    name: "Nicarágua",
  },
  {
    standardizedName: "Libyan Arab Jamahiriya",
    isoCountryCode: "LY",
    name: "Líbia",
  },
  {
    standardizedName: "Burundi",
    isoCountryCode: "BI",
    name: "Burundi",
  },
  {
    standardizedName: "Bermuda",
    isoCountryCode: "BM",
    name: "Bermudas",
  },
  {
    standardizedName: "Italy",
    isoCountryCode: "IT",
    name: "Itália",
  },
  {
    standardizedName: "Puerto Rico",
    isoCountryCode: "PR",
    name: "Porto Rico",
  },
  {
    standardizedName: "Chad",
    isoCountryCode: "TD",
    name: "Chade",
  },
  {
    standardizedName: "Turkmenistan",
    isoCountryCode: "TM",
    name: "Turcomenistão",
  },
  {
    standardizedName: "Haiti",
    isoCountryCode: "HT",
    name: "Haiti",
  },
  {
    standardizedName: "Benin",
    isoCountryCode: "BJ",
    name: "Benin",
  },
  {
    standardizedName: "Macao",
    isoCountryCode: "MO",
    name: "Macau, RAE da China",
  },
  {
    standardizedName: "Germany",
    isoCountryCode: "DE",
    name: "Alemanha",
  },
  {
    standardizedName: "Romania",
    isoCountryCode: "RO",
    name: "Romênia",
  },
  {
    standardizedName: "Malaysia",
    isoCountryCode: "MY",
    name: "Malásia",
  },
  {
    standardizedName: "Palestinian Territory, Occupied",
    isoCountryCode: "PS",
    name: "Territórios palestinos",
  },
  {
    standardizedName: "Ethiopia",
    isoCountryCode: "ET",
    name: "Etiópia",
  },
  {
    standardizedName: "Bhutan",
    isoCountryCode: "BT",
    name: "Butão",
  },
  {
    standardizedName: "Guyana",
    isoCountryCode: "GY",
    name: "Guiana",
  },
  {
    standardizedName: "Saint Lucia",
    isoCountryCode: "LC",
    name: "Santa Lúcia",
  },
  {
    standardizedName: "Djibouti",
    isoCountryCode: "DJ",
    name: "Djibuti",
  },
  {
    standardizedName: "Swaziland",
    isoCountryCode: "SZ",
    name: "Essuatíni",
  },
  {
    standardizedName: "Liberia",
    isoCountryCode: "LR",
    name: "Libéria",
  },
  {
    standardizedName: "Cape Verde",
    isoCountryCode: "CV",
    name: "Cabo Verde",
  },
  {
    standardizedName: "Azerbaijan",
    isoCountryCode: "AZ",
    name: "Azerbaijão",
  },
  {
    standardizedName: "Switzerland",
    isoCountryCode: "CH",
    name: "Suíça",
  },
  {
    standardizedName: "China, People's Republic of",
    isoCountryCode: "CN",
    name: "China",
  },
  {
    standardizedName: "Papua New Guinea",
    isoCountryCode: "PG",
    name: "Papua-Nova Guiné",
  },
  {
    standardizedName: "Algeria",
    isoCountryCode: "DZ",
    name: "Argélia",
  },
  {
    standardizedName: "Yemen",
    isoCountryCode: "YE",
    name: "Iêmen",
  },
  {
    standardizedName: "Luxembourg",
    isoCountryCode: "LU",
    name: "Luxemburgo",
  },
  {
    standardizedName: "Norway",
    isoCountryCode: "NO",
    name: "Noruega",
  },
  {
    standardizedName: "Nigeria",
    isoCountryCode: "NG",
    name: "Nigéria",
  },
  {
    standardizedName: "American Samoa",
    isoCountryCode: "AS",
    name: "Samoa Americana",
  },
  {
    standardizedName: "Saint Vincent and the Grenadines",
    isoCountryCode: "VC",
    name: "São Vicente e Granadinas",
  },
  {
    standardizedName: "India",
    isoCountryCode: "IN",
    name: "Índia",
  },
  {
    standardizedName: "Palau",
    isoCountryCode: "PW",
    name: "Palau",
  },
  {
    standardizedName: "Tunisia",
    isoCountryCode: "TN",
    name: "Tunísia",
  },
  {
    standardizedName: "Bangladesh",
    isoCountryCode: "BD",
    name: "Bangladesh",
  },
  {
    standardizedName: "French Polynesia",
    isoCountryCode: "PF",
    name: "Polinésia Francesa",
  },
  {
    standardizedName: "Sierra Leone",
    isoCountryCode: "SL",
    name: "Serra Leoa",
  },
  {
    standardizedName: "Colombia",
    isoCountryCode: "CO",
    name: "Colombia",
  },
  {
    standardizedName: "Costa Rica",
    isoCountryCode: "CR",
    name: "Costa Rica",
  },
  {
    standardizedName: "Burkina Faso",
    isoCountryCode: "BF",
    name: "Burquina Faso",
  },
  {
    standardizedName: "Japan",
    isoCountryCode: "JP",
    name: "Japão",
  },
  {
    standardizedName: "Trinidad and Tobago",
    isoCountryCode: "TT",
    name: "Trinidad e Tobago",
  },
  {
    standardizedName: "Ecuador",
    isoCountryCode: "EC",
    name: "Equador",
  },
  {
    standardizedName: "Panama",
    isoCountryCode: "PA",
    name: "Panamá",
  },
  {
    standardizedName: "Ghana",
    isoCountryCode: "GH",
    name: "Gana",
  },
  {
    standardizedName: "Pakistan",
    isoCountryCode: "PK",
    name: "Paquistão",
  },
  {
    standardizedName: "Bulgaria",
    isoCountryCode: "BG",
    name: "Bulgária",
  },
  {
    standardizedName: "Seychelles",
    isoCountryCode: "SC",
    name: "Seicheles",
  },
  {
    standardizedName: "Malta",
    isoCountryCode: "MT",
    name: "Malta",
  },
  {
    standardizedName: "UK",
    isoCountryCode: "GB",
    name: "Reino Unido",
  },
  {
    standardizedName: "Iraq",
    isoCountryCode: "IQ",
    name: "Iraque",
  },
  {
    standardizedName: "People’s Republic of China",
    isoCountryCode: "CN",
    name: "China",
  },
  {
    standardizedName: "Curaçao",
    isoCountryCode: "CW",
    name: "Curaçao",
  },
  {
    standardizedName: "Virgin Islands, U.S.",
    isoCountryCode: "VI",
    name: "Ilhas Virgens Americanas",
  },
  {
    standardizedName: "Sweden",
    isoCountryCode: "SE",
    name: "Suécia",
  },
  {
    standardizedName: "United Arab Emirates",
    isoCountryCode: "AE",
    name: "Emirados Árabes Unidos",
  },
  {
    standardizedName: "Eritrea",
    isoCountryCode: "ER",
    name: "Eritreia",
  },
  {
    standardizedName: "Spain",
    isoCountryCode: "ES",
    name: "Espanha",
  },
  {
    standardizedName: "Guinea",
    isoCountryCode: "GN",
    name: "Guiné",
  },
  {
    standardizedName: "Hong Kong",
    isoCountryCode: "HK",
    name: "Hong Kong, RAE da China",
  },
  {
    standardizedName: "Isle of Man",
    isoCountryCode: "IM",
    name: "Ilha de Man",
  },
  {
    standardizedName: "Argentina",
    isoCountryCode: "AR",
    name: "Argentina",
  },
  {
    standardizedName: "Dominican Republic",
    isoCountryCode: "DO",
    name: "República Dominicana",
  },
  {
    standardizedName: "Zambia",
    isoCountryCode: "ZM",
    name: "Zâmbia",
  },
  {
    standardizedName: "Austria",
    isoCountryCode: "AT",
    name: "Áustria",
  },
  {
    standardizedName: "Australia",
    isoCountryCode: "AU",
    name: "Austrália",
  },
  {
    standardizedName: "Kiribati",
    isoCountryCode: "KI",
    name: "Quiribati",
  },
  {
    standardizedName: "Grenada",
    isoCountryCode: "GD",
    name: "Granada",
  },
  {
    standardizedName: "Kyrgyzstan",
    isoCountryCode: "KG",
    name: "Quirguistão",
  },
  {
    standardizedName: "Madagascar",
    isoCountryCode: "MG",
    name: "Madagascar",
  },
  {
    standardizedName: "Egypt",
    isoCountryCode: "EG",
    name: "Egito",
  },
  {
    standardizedName: "Korea, Republic of",
    isoCountryCode: "KR",
    name: "Coreia do Sul",
  },
  {
    standardizedName: "Brunei Darussalam",
    isoCountryCode: "BN",
    name: "Brunei",
  },
  {
    standardizedName: "Ukraine",
    isoCountryCode: "UA",
    name: "Ucrânia",
  },
  {
    standardizedName: "Bahamas",
    isoCountryCode: "BS",
    name: "Bahamas",
  },
  {
    standardizedName: "Samoa",
    isoCountryCode: "WS",
    name: "Samoa",
  },
  {
    standardizedName: "Armenia",
    isoCountryCode: "AM",
    name: "Armênia",
  },
  {
    standardizedName: "Côte d'Ivoire",
    isoCountryCode: "CI",
    name: "Costa do Marfim",
  },
  {
    standardizedName: "Georgia",
    isoCountryCode: "GE",
    name: "Geórgia",
  },
  {
    standardizedName: "Lao People's Democratic Republic",
    isoCountryCode: "LA",
    name: "Laos",
  },
  {
    standardizedName: "Taiwan",
    isoCountryCode: "TW",
    name: "Taiwan",
  },
  {
    standardizedName: "Russian Federation",
    isoCountryCode: "RU",
    name: "Rússia",
  },
  {
    standardizedName: "Finland",
    isoCountryCode: "FI",
    name: "Finlândia",
  },
  {
    standardizedName: "Afghanistan",
    isoCountryCode: "AF",
    name: "Afeganistão",
  },
  {
    standardizedName: "Faroe Islands",
    isoCountryCode: "FO",
    name: "Ilhas Faroé",
  },
  {
    standardizedName: "Jersey",
    isoCountryCode: "JE",
    name: "Jersey",
  },
  {
    standardizedName: "Mexico",
    isoCountryCode: "MX",
    name: "México",
  },
  {
    standardizedName: "Tajikistan",
    isoCountryCode: "TJ",
    name: "Tadjiquistão",
  },
  {
    standardizedName: "Botswana",
    isoCountryCode: "BW",
    name: "Botsuana",
  },
  {
    standardizedName: "Korea, Democratic People's Republic of",
    isoCountryCode: "KP",
    name: "Coreia do Norte",
  },
  {
    standardizedName: "Czech Republic",
    isoCountryCode: "CZ",
    name: "Tchéquia",
  },
  {
    standardizedName: "Canada",
    isoCountryCode: "CA",
    name: "Canadá",
  },
  {
    standardizedName: "Greenland",
    isoCountryCode: "GL",
    name: "Groenlândia",
  },
  {
    standardizedName: "Mauritius",
    isoCountryCode: "MU",
    name: "Maurício",
  },
  {
    standardizedName: "Liechtenstein",
    isoCountryCode: "LI",
    name: "Liechtenstein",
  },
  {
    standardizedName: "Honduras",
    isoCountryCode: "HN",
    name: "Honduras",
  },
  {
    standardizedName: "Sudan",
    isoCountryCode: "SD",
    name: "Sudão",
  },
  {
    standardizedName: "Philippines",
    isoCountryCode: "PH",
    name: "Filipinas",
  },
  {
    standardizedName: "Netherlands",
    isoCountryCode: "NL",
    name: "Países Baixos",
  },
  {
    standardizedName: "Belarus",
    isoCountryCode: "BY",
    name: "Bielorrússia",
  },
  {
    standardizedName: "Poland",
    isoCountryCode: "PL",
    name: "Polônia",
  },
  {
    standardizedName: "Mongolia",
    isoCountryCode: "MN",
    name: "Mongólia",
  },
  {
    standardizedName: "Monaco",
    isoCountryCode: "MC",
    name: "Mônaco",
  },
  {
    standardizedName: "Guatemala",
    isoCountryCode: "GT",
    name: "Guatemala",
  },
  {
    standardizedName: "Iran, Islamic Republic of",
    isoCountryCode: "IR",
    name: "Irã",
  },
  {
    standardizedName: "Uzbekistan",
    isoCountryCode: "UZ",
    name: "Uzbequistão",
  },
  {
    standardizedName: "Namibia",
    isoCountryCode: "NA",
    name: "Namíbia",
  },
  {
    standardizedName: "Solomon Islands",
    isoCountryCode: "SB",
    name: "Ilhas Salomão",
  },
  {
    standardizedName: "El Salvador",
    isoCountryCode: "SV",
    name: "El Salvador",
  },
  {
    standardizedName: "Hungary",
    isoCountryCode: "HU",
    name: "Hungria",
  },
  {
    standardizedName: "Estonia",
    isoCountryCode: "EE",
    name: "Estônia",
  },
  {
    standardizedName: "Guam",
    isoCountryCode: "GU",
    name: "Guam",
  },
  {
    standardizedName: "Maldives",
    isoCountryCode: "MV",
    name: "Maldivas",
  },
  {
    standardizedName: "Somalia",
    isoCountryCode: "SO",
    name: "Somália",
  },
  {
    standardizedName: "Northern Mariana Islands",
    isoCountryCode: "MP",
    name: "Ilhas Marianas do Norte",
  },
  {
    standardizedName: "Russia",
    isoCountryCode: "RU",
    name: "Rússia",
  },
  {
    standardizedName: "South Africa",
    isoCountryCode: "ZA",
    name: "África do Sul",
  },
  {
    standardizedName: "Lesotho",
    isoCountryCode: "LS",
    name: "Lesoto",
  },
];
